import React, { Component } from 'react';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import { Loader, Content } from 'rsuite';
import OutreachAggSearchForm from '../../../../../../containers/OutreachAggSearchForm';
import PageLayout from '../../../../../../components/Reports/PageLayout';
import PageHeader from '../../../../../../components/PageHeader';
import AccessControl from '../../../../../../components/AccessControl';
import AccessDenied from '../../../../../../components/AccessDenied';
import { parseInt } from '../../../../../../helpers/utils';
import { modifyAccess } from '../../../../../../helpers/permission';
import * as PERMISSIONS from '../../../../../../constants/permissions';

class OutreachAggregateReport extends Component {
  componentDidMount() {
    const { onInit } = this.props;
    onInit();
  }

  handleSubmit = ({ locations, trackingMethods, ...restParams }) => {
    const { onSubmit } = this.props;
    const params = {
      ...restParams,
      locations: fp.filter(id => parseInt(id) > 0, locations),
      trackingMethods: fp.uniq(trackingMethods)
    };
    onSubmit(params);
  };

  render() {
    const {
      groupByOptions,
      sumOrCountByOptions,
      locationOptions,
      trackingMethodOptions,
      isFetchingColumns,
      isSaving
    } = this.props;

    return (
      <PageLayout>
        <AccessControl
          allowOnlyFor={modifyAccess(PERMISSIONS.OUTREACH_AGG_REPORT)}
          fallback={<AccessDenied />}
        >
          <PageHeader title="Generate Report" />
          <Content>
            {isFetchingColumns ? (
              <Loader content="Loading..." center />
            ) : (
              <OutreachAggSearchForm
                isSaving={isSaving}
                onSubmit={this.handleSubmit}
                groupByOptions={groupByOptions}
                sumOrCountByOptions={sumOrCountByOptions}
                locationOptions={locationOptions}
                trackingMethodOptions={trackingMethodOptions}
              />
            )}
          </Content>
        </AccessControl>
      </PageLayout>
    );
  }
}

OutreachAggregateReport.propTypes = {
  onInit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  groupByOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  sumOrCountByOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  locationOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  trackingMethodOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isFetchingColumns: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired
};

export default OutreachAggregateReport;
